// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_root__MX7Lo {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.Home_main__0K9ns {
  display: flex;
  align-items: stretch;
  height: 100%;
  flex-grow: 1;
}

.Home_content__rMt6j {
  min-width: 1px;
  flex-grow: 1;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/HomeLayout/Home.module.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EAEA,aAAA;EACA,sBAAA;AAIF;;AADA;EACE,aAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;AAIF;;AADA;EACE,cAAA;EACA,YAAA;EACA,eAAA;AAIF","sourcesContent":["@import './config.module';\n\n.root {\n  min-height: 100vh;\n  //width: 100vw;\n  display: flex;\n  flex-direction: column;\n}\n\n.main {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n  flex-grow: 1;\n}\n\n.content {\n  min-width: 1px;\n  flex-grow: 1;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarWidth": `334px`,
	"sidebarWidthCollapsed": `100px`,
	"mobileSidebarBreakpointWidth": `700px`,
	"root": `Home_root__MX7Lo`,
	"main": `Home_main__0K9ns`,
	"content": `Home_content__rMt6j`
};
export default ___CSS_LOADER_EXPORT___;
